import { queryAcharya, loadAcharyaContext, logAcharyaError, fetchAcharyaAudio } from "./acharya-service";
import { fetchAcharyaDebug } from "./acharya-api";

/**
 * Browser console:
 *   await testAcharya("What is Shiva tattva?", "user-id-or-email")
 * Second arg: user id (UUID) or email (debug only for email).
 */
export async function testAcharya(question, userIdOrEmail) {
  if (!question) {
    console.warn('[testAcharya] Usage: await testAcharya("your question", userIdOrEmail)');
    return null;
  }

  console.group(`[testAcharya] ${question.slice(0, 80)}`);

  const token = typeof localStorage !== "undefined" ? localStorage.getItem("vedaPath_token") : null;
  const isEmail = userIdOrEmail?.includes("@");

  if (isEmail) {
    try {
      const debug = await fetchAcharyaDebug(userIdOrEmail, question);
      console.log("admin debug:", debug);
    } catch (e) {
      console.warn("debug:", e?.response?.data?.detail || e.message);
    }
  }

  let userId = isEmail ? undefined : userIdOrEmail;
  let ctx = null;
  if (token) {
    ctx = await loadAcharyaContext(token);
    if (!userId && ctx.profile?.id) userId = ctx.profile.id;
    console.log("context:", ctx);
  }

  try {
    const result = await queryAcharya(question, userId, token, ctx);
    console.log("answer:", result.answer);
    console.log("tattva:", result.tattva_highlights);
    console.log("stories:", result.story_cards);
    console.log("sadhana:", result.sadhana_recommendation);
    console.log("dharma:", result.dharma_principles);
    console.log("full:", result);
    console.groupEnd();
    return result;
  } catch (e) {
    const msg = await logAcharyaError(question, e, { userId, email: isEmail ? userIdOrEmail : undefined });
    console.error("failed:", msg);
    console.groupEnd();
    return null;
  }
}

export function installAcharyaTestConsole() {
  if (typeof window !== "undefined") {
    window.testAcharya = testAcharya;
    window.testAudio = async (text = "Om Namah Shivaya", mode = "voice") => {
      const token = typeof localStorage !== "undefined" ? localStorage.getItem("vedaPath_token") : null;
      const payload = await fetchAcharyaAudio(text, mode, token, 7);
      console.log("[testAudio] payload:", payload);
      return payload;
    };
  }
}
